module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_okunai-6e1ba8fc5c6ad3ae0d704fb8dc527c01.jpg";